import { FC, SVGAttributes } from "react";

interface Props extends SVGAttributes<SVGSVGElement> {}

const UploadFileAlt: FC<Props> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_1_7385"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <rect width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1_7385)">
        <path
          d="M8.66669 25.3333C7.00335 25.3333 5.58758 24.7549 4.41935 23.598C3.25091 22.4413 2.66669 21.0274 2.66669 19.3563C2.66669 17.777 3.21024 16.4078 4.29735 15.2487C5.38469 14.0898 6.66169 13.4667 8.12835 13.3793C8.42746 11.4376 9.32058 9.83334 10.8077 8.56667C12.2948 7.30001 14.0256 6.66667 16 6.66667C18.2287 6.66667 20.1191 7.44289 21.6714 8.99534C23.2238 10.5476 24 12.438 24 14.6667V16H24.8207C26.0976 16.0411 27.1689 16.5099 28.0347 17.4063C28.9005 18.303 29.3334 19.3898 29.3334 20.6667C29.3334 21.9744 28.891 23.0791 28.0064 23.9807C27.1217 24.8824 26.0256 25.3333 24.718 25.3333H17.4874C16.8736 25.3333 16.3611 25.1278 15.95 24.7167C15.5389 24.3056 15.3334 23.7931 15.3334 23.1793V15.441L12.5334 18.2257L11.5897 17.3077L16 12.8973L20.4104 17.3077L19.4667 18.2257L16.6667 15.441V23.1793C16.6667 23.3847 16.7521 23.5728 16.923 23.7437C17.0939 23.9146 17.282 24 17.4874 24H24.6667C25.6 24 26.3889 23.6778 27.0334 23.0333C27.6778 22.3889 28 21.6 28 20.6667C28 19.7333 27.6778 18.9444 27.0334 18.3C26.3889 17.6556 25.6 17.3333 24.6667 17.3333H22.6667V14.6667C22.6667 12.8222 22.0167 11.25 20.7167 9.95001C19.4167 8.65001 17.8445 8.00001 16 8.00001C14.1556 8.00001 12.5834 8.65001 11.2834 9.95001C9.98335 11.25 9.33335 12.8222 9.33335 14.6667H8.61535C7.3778 14.6667 6.29913 15.1222 5.37935 16.0333C4.4598 16.9444 4.00002 18.0444 4.00002 19.3333C4.00002 20.6222 4.45558 21.7222 5.36669 22.6333C6.2778 23.5444 7.3778 24 8.66669 24H12V25.3333H8.66669Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export { UploadFileAlt };
